'use client'

import { onOpenMap } from '@/app/[locale]/_store/common/common.slice'
import { Button } from '@/components/ui/button'
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
} from '@/components/ui/dialog'
import { Text } from '@chakra-ui/react'
import { useDispatch } from 'react-redux'

interface IDialog {
  isWarning?: boolean
  isOpen: boolean
  onClose: () => void
  title?: string
  onConfirm?: () => void
  description?: string
  closeOnConfirm?: boolean
  confirmText: string
  children?: React.ReactNode
}

export default function ErrorModal({
  isWarning,
  isOpen,
  onClose,
  title,
  description,
  confirmText,
  children,
}: IDialog) {
  const dispatch = useDispatch()

  const handleConfirm = () => {
    onClose()
    setTimeout(() => {
      dispatch(onOpenMap())
    }, 0)
  }

  return (
    <DialogRoot
      size={'xs'}
      id="header-error-modal"
      placement={'center'}
      motionPreset="slide-in-bottom"
      open={isOpen}
      lazyMount
      onOpenChange={onClose}
    >
      <DialogContent borderRadius="20px" mx={4}>
        <DialogHeader>
          <DialogTitle textAlign={'center'}>{title}</DialogTitle>
        </DialogHeader>
        {(children || description) && (
          <DialogBody>
            <Text textAlign="center">{description}</Text>
            {children}
          </DialogBody>
        )}

        <DialogFooter justifyContent="center">
          <Button
            size="xl"
            rounded={16}
            type="submit"
            bg={isWarning ? 'red.500' : 'primary'}
            onClick={handleConfirm}
            flex={1}
          >
            {confirmText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  )
}
